import React from 'react';
import { supportLink } from '../../config';
import { Divider, Header } from '@solarwindscloud/nighthawk-ui';
import { UnifiedLayout } from '../../layouts/UnifiedLayout/UnifiedLayout';

export const dataTestIds = {
  verificationTokenNotFound: 'verification-token-not-found',
  contactSupport: 'contact-support',
};

const VerificationTokenNotFound = () => {
  return (
    <UnifiedLayout
      headerText="Invalid Verification Link"
      dataTestId={dataTestIds.verificationTokenNotFound}
      dataTestPageName="VerificationTokenNotFound"
    >
      <Header textAlign="center">
        <Header.Subheader>
          Your verification link is invalid.
          <Divider hidden />
          If you need help,{' '}
          <a href={supportLink} data-test-id={dataTestIds.contactSupport}>
            contact our support team
          </a>
          .
        </Header.Subheader>
      </Header>
    </UnifiedLayout>
  );
};

export default VerificationTokenNotFound;
